import { useEffect } from 'react';
import { pageTitleService } from '../services/PageTitle';

export default function useTitle(title: string) {
    useEffect(() => {
        pageTitleService.setPageTitle(title);
    }, [title]);
}
